import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useOwlbertWebAuth } from './auth/OwlbertWebAuthContext'
import { AccountPage } from './pages/AccountPage'
import { AssistantsConfigPage } from './pages/AssistantsConfigPage'
import { AssistantsPage } from './pages/AssistantsPage'
import { SettingsPage } from './pages/SettingsPage'
import { UserDocumentsPage } from './pages/UserDocumentsPage'
import { WebBasicShell } from './WebBasicShell'
import { WebLoginPage } from './WebLoginPage'

/** Routes behind hosted sign-in; unauthenticated users see {@link WebLoginPage} only. */
export const WebAuthedRoutes: React.FC = () => {
  const auth = useOwlbertWebAuth()

  if (!auth.sessionReady) {
    return <WebLoginPage />
  }

  return (
    <Routes>
      <Route path="/" element={<WebBasicShell />}>
        <Route index element={<Navigate to="/assistants" replace />} />
        <Route path="assistants/:sessionId" element={<AssistantsPage />} />
        <Route path="assistants" element={<AssistantsPage />} />
        <Route path="assistants-config" element={<AssistantsConfigPage />} />
        <Route path="user-documents" element={<UserDocumentsPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="settings/:sectionKey" element={<SettingsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/assistants" replace />} />
      </Route>
    </Routes>
  )
}
